import AppAdapter from 'adapters/app';
import Axios from 'utils/axios';

// Calendar integration endpoints return plain JSON (not JSON:API), so this
// adapter calls them directly through the authed axios instance.
class CalendarAdapter extends AppAdapter {
  static base(providerId) {
    return `${AppAdapter.baseURL()}/providers/${providerId}/calendar`;
  }

  // GET status: { data: [integrations], providers: { google, apple_caldav } }
  static async status(providerId) {
    const res = await new Axios().instance().get(this.base(providerId));
    return res.data;
  }

  // GET the Google consent URL: { url }
  static async googleConnectUrl(providerId) {
    const res = await new Axios().instance().get(`${this.base(providerId)}/google/connect`);
    return res.data;
  }

  // POST Apple CalDAV credentials: { appleId, appPassword }
  static async connectApple(providerId, payload) {
    const res = await new Axios().instance().post(`${this.base(providerId)}/apple`, payload);
    return res.data;
  }

  // PATCH toggles: { pullEnabled?, pushEnabled? }
  static async setToggles(providerId, id, payload) {
    const res = await new Axios().instance().patch(`${this.base(providerId)}/${id}`, payload);
    return res.data;
  }

  static async disconnect(providerId, id) {
    const res = await new Axios().instance().delete(`${this.base(providerId)}/${id}`);
    return res.data;
  }
}

export default CalendarAdapter;
